module.exports = __webpack_public_path__ + "static/p23-99262f4ad2945843e893703b0fafa7c5.jpg";